const activityListStyles = (theme) => ({
  activityList: {
    padding: '0 0 15px',
    position: 'relative',
  },
  activityLogList: {
    display: 'inline-block',
    width: '100%',
    fontSize: '13px',
    lineHeight: '24px',
  },
});

export default activityListStyles;
